var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.605,
    height: 30.726,
    viewBox: "0 0 35.605 30.726",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2661",
    "data-name": "Group 2661",
    transform: "translate(-0.273 -0.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14155",
    "data-name": "Path 14155",
    d: "M16.185,15.342A15.456,15.456,0,0,0,.75,28.817a1.919,1.919,0,0,0,1.889,2.165l7.449.062a12.753,12.753,0,0,0,7.006-2.021l5.886-3.775a12.77,12.77,0,0,1,6.9-2.022h5.229M23.176,8.321a6.947,6.947,0,0,1-6.991,7.025,7.156,7.156,0,0,1-7.1-7.087,6.942,6.942,0,0,1,6.991-7.024,7.092,7.092,0,0,1,4.307,1.481,7.267,7.267,0,0,1,1.6,1.709A7.094,7.094,0,0,1,23.176,8.321Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.917
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14156",
    "data-name": "Path 14156",
    d: "M26.146,16.889l8.968,6.724-8.968,6.729",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.917
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/Customer.a1bd61c6de056932ecda5f372392727b.svg";
export { ForwardRef as ReactComponent };